import { render, staticRenderFns } from "./SearchNavItemCompany.vue?vue&type=template&id=b97ff3ea&scoped=true&"
import script from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemCompany.vue?vue&type=style&index=0&id=b97ff3ea&prod&scoped=true&lang=css&"
import style1 from "./SearchNavItemCompany.vue?vue&type=style&index=1&id=b97ff3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97ff3ea",
  null
  
)

export default component.exports